import React from 'react'
import { useSeo } from '../../lib/i18n'

export default function OpstartEn() {
  useSeo({
    title: 'When Can I Start? | Borgs Driving School Kalundborg',
    description: 'Learn about age requirements, parental consent, and statutory minimum requirements for driver training in Denmark.',
    lang: 'en',
    pathname: '/en/start-dates'
  })

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 sm:p-12 border border-slate-200 shadow-sm space-y-8">
          <div>
            <h1 className="font-header text-3xl sm:text-4xl font-extrabold text-slate-900">
              When Can I Start?
            </h1>
            <p className="mt-2 text-slate-900 font-bold text-lg">
              What is required to get a driving licence for a standard car?
            </p>
          </div>

          <div className="space-y-6 text-slate-700 leading-relaxed">
            <ul className="list-disc list-inside space-y-2 text-slate-700">
              <li>
                You must be 17 years old to obtain a driving licence. You can start lessons 3 months before turning 17.
              </li>
              <li>
                You may take the official theory test 1 month before turning 17.
              </li>
              <li>
                The practical driving test can only be taken on or after your 17th birthday.
              </li>
            </ul>

            <p>
              If you are under 18 years old, you must have parental consent signed by both parents if they share parental custody.
            </p>

            <section className="space-y-3 pt-4 border-t border-slate-200">
              <h2 className="font-header text-2xl font-bold text-slate-900">
                Statutory minimum requirements for instruction:
              </h2>
              <ul className="list-disc list-inside space-y-1.5 pl-2 text-slate-800 font-medium">
                <li>29 lessons in theory</li>
                <li>3 lessons on a closed manoeuvre track (kravlegård)</li>
                <li>17 practical driving lessons on the road</li>
                <li>4 lessons on a technical skid track (glatbane)</li>
              </ul>
            </section>

            <section className="space-y-4 pt-4 border-t border-slate-200">
              <h3 className="font-header text-xl font-bold text-slate-900">
                Expect to use more driving lessons than the statutory minimum
              </h3>
              <p>
                We follow the Danish Road Safety Agency's module plan, and driver training is structured into 5 modules.
              </p>
              <p>
                Not all students complete the course and pass the theory or practical driving test without extra practice beyond statutory minimums. Therefore, expect to practice theory tests at home and take additional driving hours.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
